(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* =========================
     Money formatting (cents -> shop money format)
     ========================= */
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var noDecimals = Math.round(cents / 100).toString();
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/<[^>]+>/g, '');
  }

  function animateCount(el, target, duration) {
    if (!el) return;
    if (prefersReducedMotion) { el.textContent = target; return; }
    var start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(target * eased);
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = target;
    }
    requestAnimationFrame(tick);
  }

  function setCartCount(n) {
    $$('.cart-count').forEach(function (el) {
      el.textContent = n;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  /* =========================
     Global scroll core
     ========================= */
  var lastScrollY = 0;

  function onScroll() {
    var progressBar = $('#scrollProgress');
    var header = $('.site-header');
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (progressBar) {
      progressBar.style.transform = 'scaleX(' + (max > 0 ? window.scrollY / max : 0) + ')';
    }
    if (header) {
      header.classList.toggle('compact', window.scrollY > 80);
      header.classList.toggle('hide', window.scrollY > lastScrollY && window.scrollY > 280);
    }
    lastScrollY = window.scrollY;
    updateAppBar();
    updateRitual();
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* =========================
     Marquees — seamless loop (announcement + trust bar)
     ========================= */
  function initMarquees(root) {
    $$('.announcement-track, .trust-marquee-track', root).forEach(function (track) {
      if (track.dataset.marqueeReady) return;
      track.dataset.marqueeReady = '1';
      var group = track.firstElementChild;
      if (!group) return;
      while (track.scrollWidth < window.innerWidth + group.scrollWidth) {
        var clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
      Array.prototype.slice.call(track.children).forEach(function (child) {
        var clone = child.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    });
  }

  /* =========================
     Scroll reveal
     ========================= */
  function initReveal(root) {
    var els = $$('[data-reveal]:not(.in)', root);
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* =========================
     Product configurator
     ========================= */
  function initConfigurator(root) {
    var section = $('[data-configurator]', root);
    if (!section || section.dataset.ready) return;
    section.dataset.ready = '1';

    var productJson = null;
    var jsonEl = $('[data-product-json]', section);
    if (jsonEl) {
      try { productJson = JSON.parse(jsonEl.textContent); } catch (e) { productJson = null; }
    }

    var state = {
      flavor: null,
      pack: null,
      subscribe: false,
    };

    var flavorCards = $$('.flavor-card', section);
    var packCards = $$('.pack-card', section);
    var optionCards = $$('.option-card', section);
    var priceRoll = $('.price-roll', section);
    var priceInner = priceRoll && priceRoll.querySelector('.price-roll-inner');
    var appBarPrice = $('#appBarPrice');
    var addBtn = $('.add-to-cart', section);

    var heroVisual = $('.hero-visual', section);
    var selectedFlavor = $('.flavor-card.selected', section); // no default — shopper must choose
    var selectedPack = $('.pack-card.selected', section) || packCards[0];
    state.flavor = selectedFlavor ? selectedFlavor.dataset.flavor : null;
    state.pack = selectedPack ? selectedPack.dataset.pack : null;

    function findVariant(flavor, pack) {
      if (!productJson || !productJson.variants) return null;
      return productJson.variants.filter(function (v) {
        var opts = v.options.map(function (o) { return String(o).toLowerCase(); });
        var okFlavor = !flavor || opts.indexOf(String(flavor).toLowerCase()) !== -1;
        var okPack = !pack || opts.indexOf(String(pack).toLowerCase()) !== -1;
        return okFlavor && okPack;
      })[0] || null;
    }

    function currentPricing() {
      var variant = findVariant(state.flavor, state.pack);
      if (variant) {
        var price = variant.price;
        var planId = null;
        if (state.subscribe && variant.selling_plans && variant.selling_plans.length) {
          price = variant.selling_plans[0].price;
          planId = variant.selling_plans[0].plan_id;
        }
        return { cents: price, variantId: variant.id, planId: planId, available: variant.available };
      }
      // Demo fallback — pack cards carry data-price (dollars) + data-subscribe-discount
      var pack = $('.pack-card.selected', section);
      if (!pack) return null;
      var dollars = parseFloat(pack.dataset.price || '0');
      var discount = parseFloat(pack.dataset.subscribeDiscount || '0');
      if (state.subscribe && discount > 0) dollars = dollars * (1 - discount / 100);
      return { cents: Math.round(dollars * 100), variantId: null, planId: null, available: true };
    }

    function renderPackPrices() {
      packCards.forEach(function (card) {
        var priceEl = card.querySelector('.pack-price');
        if (!priceEl) return;
        var variant = findVariant(state.flavor, card.dataset.pack);
        if (!variant) return;
        priceEl.textContent = formatMoney(variant.price);
        var perCanEl = card.querySelector('.pack-perk-percan');
        var cans = parseInt(card.dataset.cans || '1', 10);
        if (perCanEl && cans > 1) {
          perCanEl.textContent = formatMoney(Math.floor(variant.price / cans)) + ' per can';
        }
      });
    }

    function renderPrice() {
      var pricing = currentPricing();
      if (!pricing) return;
      var text = formatMoney(pricing.cents);
      if (priceInner && priceInner.textContent !== text) {
        priceInner.textContent = text;
        if (priceRoll) {
          priceRoll.classList.remove('rolling');
          void priceRoll.offsetWidth;
          priceRoll.classList.add('rolling');
        }
      }
      if (appBarPrice) appBarPrice.textContent = text;
      if (addBtn) addBtn.disabled = !pricing.available;
    }

    function setSelected(group, target) {
      group.forEach(function (el) { el.classList.remove('selected'); });
      target.classList.add('selected');
    }

    flavorCards.forEach(function (card) {
      card.addEventListener('click', function () {
        setSelected(flavorCards, card);
        state.flavor = card.dataset.flavor;
        if (heroVisual) heroVisual.classList.add('flavor-chosen');
        // ambient glow follows the chosen flavor
        $$('.hero-glow', section).forEach(function (g) {
          g.classList.toggle('active', g.dataset.glow === card.dataset.flavor);
        });
        // dim the can of the flavor that isn't selected (active = un-dimmed)
        $$('.hero-dim', section).forEach(function (d) {
          d.classList.toggle('active', d.dataset.dim === card.dataset.flavor);
        });
        // hero product image swaps to the chosen flavor
        $$('.hero-image-flavor', section).forEach(function (img) {
          img.classList.toggle('active', img.dataset.flavorImage === card.dataset.flavor);
        });
        renderPackPrices();
        renderPrice();
      });
    });

    packCards.forEach(function (card) {
      card.addEventListener('click', function () {
        setSelected(packCards, card);
        state.pack = card.dataset.pack;
        renderPrice();
      });
    });

    optionCards.forEach(function (card) {
      card.addEventListener('click', function () {
        setSelected(optionCards, card);
        state.subscribe = card.dataset.option === 'subscribe';
        renderPrice();
      });
    });

    function nudgeFlavor() {
      flavorCards.forEach(function (c) { c.classList.remove('nudge'); void c.offsetWidth; c.classList.add('nudge'); });
      var step = flavorCards[0] && flavorCards[0].closest('.config-step');
      if (step) step.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
    }

    function addToCart() {
      if (!state.flavor) { nudgeFlavor(); return false; }
      var pricing = currentPricing();
      if (!pricing) return;
      if (!pricing.variantId) {
        // demo mode (no product assigned): just bump the count
        setCartCount((parseInt($('.cart-count') && $('.cart-count').textContent, 10) || 0) + 1);
        return;
      }
      // form-encoded, not JSON: subscription apps' cart middleware
      // (e.g. Appstle) can 503 on JSON bodies that include selling_plan
      var body = new URLSearchParams();
      body.append('id', pricing.variantId);
      body.append('quantity', 1);
      if (pricing.planId) body.append('selling_plan', pricing.planId);
      var addUrl = (window.theme.routes && window.theme.routes.cartAdd) || '/cart/add';
      if (!/\.js$/.test(addUrl)) addUrl += '.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: body.toString(),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch('/cart.js').then(function (c) { return c.json(); });
        })
        .then(function (cart) { setCartCount(cart.item_count); })
        .catch(function () {
          if (addBtn) {
            addBtn.classList.add('error');
            setTimeout(function () { addBtn.classList.remove('error'); }, 1200);
          }
        });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!state.flavor) { addToCart(); return; } // nudge to pick a flavor, no fly animation
        var cartBtn = $('.cart-btn');
        if (prefersReducedMotion || !cartBtn) { addToCart(); return; }
        var from = addBtn.getBoundingClientRect();
        var to = cartBtn.getBoundingClientRect();
        var dot = document.createElement('span');
        dot.className = 'fly-dot';
        dot.style.left = from.left + from.width / 2 + 'px';
        dot.style.top = from.top + from.height / 2 + 'px';
        document.body.appendChild(dot);
        var dx = to.left + to.width / 2 - (from.left + from.width / 2);
        var dy = to.top + to.height / 2 - (from.top + from.height / 2);
        var anim = dot.animate(
          [
            { transform: 'translate(0,0) scale(1)', opacity: 1 },
            { transform: 'translate(' + dx * 0.5 + 'px,' + (dy - 120) + 'px) scale(0.9)', opacity: 1, offset: 0.55 },
            { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.3)', opacity: 0.6 },
          ],
          { duration: 700, easing: 'cubic-bezier(0.3, 0, 0.4, 1)' }
        );
        anim.onfinish = function () { dot.remove(); };
        addToCart();
      });
    }

    var appBarAdd = $('#appBarAdd');
    if (appBarAdd && !appBarAdd.dataset.ready) {
      appBarAdd.dataset.ready = '1';
      appBarAdd.addEventListener('click', function () {
        if (addToCart() === false) return;
        appBarAdd.textContent = 'ADDED ✓';
        appBarAdd.classList.add('added');
        setTimeout(function () {
          appBarAdd.textContent = 'ADD TO CART';
          appBarAdd.classList.remove('added');
        }, 1200);
      });
    }

    renderPackPrices();
    renderPrice();
  }

  /* Mobile app bar — shows once the in-page add-to-cart scrolls away */
  function updateAppBar() {
    var appBar = $('#appBar');
    var addBtn = $('.add-to-cart');
    if (!appBar || !addBtn) return;
    var passed = addBtn.getBoundingClientRect().bottom < 0;
    appBar.classList.toggle('show', passed);
    appBar.setAttribute('aria-hidden', passed ? 'false' : 'true');
  }

  /* =========================
     Flavor explorer
     ========================= */
  function initFlavorExplorer(root) {
    var fx = $('.fx', root);
    if (!fx || fx.dataset.ready) return;
    fx.dataset.ready = '1';

    var btns = $$('.fx-switch-btn', fx);
    var panes = $$('.fx-pane', fx);
    var washes = $$('.fx-wash', fx);
    var ghosts = $$('.fx-ghost-word', fx);
    var fxSwitch = $('.fx-switch', fx);
    var stage = $('.fx-stage', fx);

    if (fxSwitch) fxSwitch.style.setProperty('--fx-tabs', btns.length || 2);

    function sizeStage() {
      if (!stage) return;
      var max = 0;
      panes.forEach(function (p) { max = Math.max(max, p.offsetHeight); });
      if (max > 0) stage.style.height = max + 'px';
    }
    window.addEventListener('load', sizeStage);
    window.addEventListener('resize', sizeStage);
    sizeStage();

    function counts(pane) {
      if (!pane) return;
      $$('.cnt', pane).forEach(function (el, i) {
        var target = parseInt(el.dataset.target, 10) || 0;
        setTimeout(function () { animateCount(el, target, 900); }, 250 + i * 120);
      });
    }

    function setFlavor(id, index) {
      btns.forEach(function (b, i) {
        var on = b.dataset.flavor === id;
        b.classList.toggle('active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && fxSwitch) {
          fxSwitch.style.setProperty('--fx-i', i);
          fxSwitch.style.setProperty('--fx-thumb', b.dataset.accent || '');
          fxSwitch.style.setProperty('--fx-thumb-text', b.dataset.thumbText || '#0a0a0a');
        }
      });
      washes.forEach(function (w) { w.classList.toggle('active', w.dataset.flavor === id); });
      ghosts.forEach(function (g) { g.classList.toggle('active', g.dataset.ghost === id); });
      panes.forEach(function (p) {
        var on = p.dataset.pane === id;
        p.classList.toggle('active', on);
        if (on) counts(p);
      });
    }

    btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () { setFlavor(btn.dataset.flavor, i); });
    });

    if (btns.length) setFlavorInit();
    function setFlavorInit() {
      var first = $('.fx-switch-btn.active', fx) || btns[0];
      // sync vars without re-running count-up (observer below handles first run)
      btns.forEach(function (b, i) {
        if (b === first && fxSwitch) {
          fxSwitch.style.setProperty('--fx-i', i);
          fxSwitch.style.setProperty('--fx-thumb', b.dataset.accent || '');
          fxSwitch.style.setProperty('--fx-thumb-text', b.dataset.thumbText || '#0a0a0a');
        }
      });
    }

    if ('IntersectionObserver' in window && stage) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            counts($('.fx-pane.active', fx));
            obs.disconnect();
          }
        });
      }, { threshold: 0.3 });
      obs.observe(stage);
    }

    if (!prefersReducedMotion) {
      fx.addEventListener('mousemove', function (e) {
        var rect = fx.getBoundingClientRect();
        var rx = (e.clientX - rect.left) / rect.width - 0.5;
        var ry = (e.clientY - rect.top) / rect.height - 0.5;
        $$('.fx-pane.active [data-parallax]', fx).forEach(function (el) {
          el.style.transform = 'translate(' + rx * 18 + 'px,' + ry * 14 + 'px)';
        });
      });
      fx.addEventListener('mouseleave', function () {
        $$('[data-parallax]', fx).forEach(function (el) { el.style.transform = ''; });
      });
    }
  }

  /* =========================
     How to use — scroll timeline
     ========================= */
  function initRitual(root) {
    var right = $('.ritual-right', root);
    if (!right || right.dataset.ready) return;
    right.dataset.ready = '1';
    sizeRitualRail();
    window.addEventListener('load', sizeRitualRail);
    window.addEventListener('resize', sizeRitualRail);
  }

  function sizeRitualRail() {
    var right = $('.ritual-right');
    if (!right) return;
    var steps = $$('[data-step]', right);
    var rail = $('.ritual-rail', right);
    if (!rail || !steps.length) return;
    function center(step) {
      var num = step.querySelector('.ritual-num');
      if (!num) return step.offsetTop;
      return step.offsetTop + num.offsetTop + num.offsetHeight / 2;
    }
    var top = center(steps[0]);
    rail.style.top = top + 'px';
    rail.style.height = center(steps[steps.length - 1]) - top + 'px';
  }

  function updateRitual() {
    var right = $('.ritual-right');
    if (!right) return;
    var railFill = $('.ritual-rail-fill', right);
    var steps = $$('[data-step]', right);
    var rect = right.getBoundingClientRect();
    var focus = window.innerHeight * 0.6;
    var progress = Math.min(1, Math.max(0, (focus - rect.top) / rect.height));
    if (railFill) railFill.style.height = progress * 100 + '%';
    steps.forEach(function (step) {
      step.classList.toggle('active', step.getBoundingClientRect().top < focus);
    });
  }

  /* =========================
     Comparison — head-to-head
     ========================= */
  function initVersus(root) {
    var arena = $('.versus-arena', root);
    if (!arena || arena.dataset.ready) return;
    arena.dataset.ready = '1';

    var section = arena.closest('.versus') || document;
    var rivalDial = $('.dial-fill-rival', arena);
    var stateDial = $('.dial-fill-state', arena);
    var rivalScore = $('[data-rival-score]', arena);
    var stateScore = $('[data-state-score]', arena);
    var rows = $$('.versus-row', arena);
    var picks = $$('.versus-pick', section);
    var picker = $('.versus-picker', section);
    var CIRC = 326.7;

    rows.forEach(function (row, i) { row.style.setProperty('--row', i); });

    function render(rival) {
      arena.dataset.rival = rival;
      picks.forEach(function (p, i) {
        var on = p.dataset.rival === rival;
        p.classList.toggle('active', on);
        if (on && picker) picker.classList.toggle('pouches', i === 1);
      });
      $$('.rival-label', arena).forEach(function (l) {
        l.style.display = l.dataset.rivalLabel === rival ? 'block' : 'none';
      });

      var wins = 0;
      var total = rows.length || 5;
      rows.forEach(function (row) {
        var verdict = row.getAttribute('data-' + rival) || 'fail';
        var cell = row.querySelector('.versus-cell-rival');
        if (cell) {
          cell.classList.remove('pass', 'partial', 'fail');
          cell.classList.add(verdict);
        }
        if (verdict === 'pass' || verdict === 'partial') wins++;
      });

      arena.classList.remove('armed');
      void arena.offsetWidth;
      arena.classList.add('armed');

      if (rivalDial) rivalDial.style.strokeDashoffset = CIRC;
      if (stateDial) stateDial.style.strokeDashoffset = CIRC;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (rivalDial) rivalDial.style.strokeDashoffset = CIRC * (1 - wins / total);
          if (stateDial) stateDial.style.strokeDashoffset = 0;
        });
      });
      animateCount(rivalScore, wins, 1000);
      animateCount(stateScore, total, 1000);
    }

    picks.forEach(function (pick) {
      pick.addEventListener('click', function () { render(pick.dataset.rival); });
    });

    var first = picks.length ? picks[0].dataset.rival : 'r1';
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            render(first);
            obs.disconnect();
          }
        });
      }, { threshold: 0.3 });
      obs.observe(arena);
    } else {
      render(first);
    }
  }

  /* =========================
     FAQ accordion
     ========================= */
  function initFaq(root) {
    $$('.faq2-q', root).forEach(function (q) {
      if (q.dataset.ready) return;
      q.dataset.ready = '1';
      var head = q.querySelector('.faq2-q-head');
      if (!head) return;
      head.addEventListener('click', function () {
        var isOpen = q.classList.contains('open');
        $$('.faq2-q.open').forEach(function (other) {
          other.classList.remove('open');
          var h = other.querySelector('.faq2-q-head');
          if (h) h.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          q.classList.add('open');
          head.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* =========================
     Newsletter — AJAX submit, no page reload
     ========================= */
  function initNewsletter(root) {
    $$('[data-newsletter]', root).forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var form = wrap.querySelector('form');
      var input = wrap.querySelector('.newsletter-input');
      var btn = wrap.querySelector('.newsletter-btn');
      if (!form || !input) return;

      function showMsg(text, ok) {
        var old = wrap.querySelector('.newsletter-msg');
        if (old) old.remove();
        var p = document.createElement('p');
        p.className = 'newsletter-msg ' + (ok ? 'newsletter-msg-ok' : 'newsletter-msg-err');
        p.textContent = text;
        form.appendChild(p);
        requestAnimationFrame(function () { p.classList.add('show'); });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = input.value.trim();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showMsg(wrap.dataset.error || 'Please enter a valid email.', false);
          return;
        }
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = '...'; }
        // Relay to Omnisend via our server (same endpoint as the popup)
        var url = wrap.dataset.subscribeUrl || 'https://state.crackedcreative.com/subscribe';
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, tags: ['newsletter'] }),
        })
          .then(function (r) {
            if (btn) { btn.disabled = false; btn.textContent = label; }
            if (r.ok) {
              input.value = '';
              showMsg(wrap.dataset.success || 'Thanks for subscribing!', true);
            } else {
              showMsg(wrap.dataset.error || 'Something went wrong.', false);
            }
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
            showMsg(wrap.dataset.error || 'Something went wrong.', false);
          });
      });
    });
  }

  /* =========================
     Welcome offer popup
     ========================= */
  function initPromo(root) {
    var promo = $('.promo', root) || $('.promo');
    if (!promo || promo.dataset.ready) return;
    promo.dataset.ready = '1';

    var cfg = {
      delay: (parseInt(promo.dataset.delay, 10) || 2) * 1000,
      once: promo.dataset.once === 'true',
      minutes: parseInt(promo.dataset.minutes, 10) || 10,
      pct: parseInt(promo.dataset.pct, 10) || 10,
    };

    var stepsWrap = $('.promo-steps', promo);
    var stepEls = $$('.promo-step', promo);
    var progress = $('.promo-progress span', promo);
    var timerEl = $('[data-promo-timer]', promo);
    var card = $('.promo-card', promo);
    var timerId = null;

    function sizeSteps() {
      var active = $('.promo-step.active', promo);
      if (active && stepsWrap) stepsWrap.style.height = active.offsetHeight + 'px';
    }
    window.addEventListener('resize', sizeSteps);

    function goToStep(n) {
      stepEls.forEach(function (s) {
        var on = parseInt(s.dataset.step, 10) === n;
        s.classList.toggle('leaving', s.classList.contains('active') && !on);
        s.classList.toggle('active', on);
        if (on) s.classList.remove('leaving');
      });
      if (progress) progress.style.width = (n / stepEls.length) * 100 + '%';
      sizeSteps();
    }

    function startTimer() {
      var remaining = cfg.minutes * 60;
      function render() {
        if (!timerEl) return;
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;
        timerEl.textContent = m + ':' + String(s).padStart(2, '0');
      }
      render();
      timerId = setInterval(function () {
        if (remaining > 0) { remaining--; render(); }
        else clearInterval(timerId);
      }, 1000);
    }

    function openPromo() {
      promo.classList.add('open');
      promo.setAttribute('aria-hidden', 'false');
      document.body.classList.add('promo-open');
      goToStep(1);
      startTimer();
      if (cfg.once) {
        try { sessionStorage.setItem('state-promo-seen', '1'); } catch (e) {}
      }
    }

    function closePromo() {
      promo.classList.remove('open');
      promo.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('promo-open');
      if (timerId) clearInterval(timerId);
    }

    $$('[data-promo-close]', promo).forEach(function (el) {
      el.addEventListener('click', closePromo);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && promo.classList.contains('open')) closePromo();
    });

    $$('.promo-goal', promo).forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.add('picked');
        var goalEl = $('[data-promo-goal]', promo);
        if (goalEl) goalEl.textContent = btn.textContent.trim();
        setTimeout(function () {
          goToStep(2);
          animateCount($('[data-promo-pct]', promo), cfg.pct, 900);
          setTimeout(function () {
            var input = $('.promo-input', promo);
            if (input) input.focus();
          }, 500);
        }, 420);
      });
    });

    function confetti() {
      if (prefersReducedMotion) return;
      var body = $('.promo-body', promo);
      if (!body) return;
      var colors = ['#f48123', '#18c078', '#3dd090', '#0a0a0a'];
      for (var i = 0; i < 40; i++) {
        var c = document.createElement('span');
        c.className = 'promo-confetti';
        c.style.background = colors[i % colors.length];
        c.style.setProperty('--tx', (Math.random() - 0.5) * 460 + 'px');
        c.style.setProperty('--ty', (Math.random() - 0.85) * 420 + 'px');
        c.style.setProperty('--rot', (Math.random() - 0.5) * 720 + 'deg');
        c.style.animationDelay = Math.random() * 0.15 + 's';
        body.appendChild(c);
        (function (el) { setTimeout(function () { el.remove(); }, 1400); })(c);
      }
    }

    // Relay signups to Omnisend via our server (reliable, no Shopify captcha; sets email + SMS consent)
    var SUBSCRIBE_URL = (promo.dataset.subscribeUrl || 'https://state.crackedcreative.com/subscribe');
    var capturedEmail = '';
    function subscribe(fields) {
      fetch(SUBSCRIBE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: fields.email || undefined,
          phone: fields.phone || undefined,
          tags: (fields.tags || 'newsletter,popup').split(','),
        }),
      }).catch(function () {});
    }

    // Step 2 → email: capture and advance to the SMS step
    var emailForm = $('.promo-step[data-step="2"] .promo-form', promo);
    if (emailForm) {
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = $('.promo-input', emailForm);
        var email = input ? input.value.trim() : '';
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          emailForm.classList.remove('error');
          void emailForm.offsetWidth;
          emailForm.classList.add('error');
          return;
        }
        capturedEmail = email;
        subscribe({ email: email, tags: 'newsletter,popup' });
        goToStep(3);
        setTimeout(function () {
          var phone = $('.promo-input-phone', promo);
          if (phone) phone.focus();
        }, 500);
      });
    }

    function finishPromo() {
      goToStep(4);
      setTimeout(confetti, 350);
    }

    // Step 3 → SMS: capture phone (optional) then advance to success
    var smsForm = $('.promo-form-sms', promo);
    if (smsForm) {
      smsForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = $('.promo-input-phone', smsForm);
        var phone = input ? input.value.trim() : '';
        var digits = phone.replace(/[^\d]/g, '');
        if (digits.length < 10) {
          smsForm.classList.remove('error');
          void smsForm.offsetWidth;
          smsForm.classList.add('error');
          return;
        }
        subscribe({ email: capturedEmail, phone: phone, tags: 'newsletter,popup,sms' });
        finishPromo();
      });
    }
    var smsSkip = $('[data-promo-sms-skip]', promo);
    if (smsSkip) smsSkip.addEventListener('click', finishPromo);

    var copyBtn = $('.promo-copy', promo);
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var codeEl = $('.promo-code-value', promo);
        var code = codeEl ? codeEl.textContent.trim() : '';
        var done = function () {
          copyBtn.textContent = 'COPIED ✓';
          copyBtn.classList.add('copied');
          setTimeout(function () {
            copyBtn.textContent = 'COPY';
            copyBtn.classList.remove('copied');
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else { done(); }
      });
    }

    var shopBtn = $('.promo-shop', promo);
    if (shopBtn) {
      shopBtn.addEventListener('click', function () {
        closePromo();
        var shop = $('#shop');
        if (shop) shop.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      });
    }

    // Bottom-sheet swipe-to-dismiss
    var grabber = $('.promo-grabber', promo);
    if (grabber && card) {
      var dragging = false, startY = 0, dy = 0;
      grabber.addEventListener('touchstart', function (e) {
        dragging = true;
        startY = e.touches[0].clientY;
        dy = 0;
        card.style.transition = 'none';
      }, { passive: true });
      grabber.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        dy = Math.max(0, e.touches[0].clientY - startY);
        card.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      grabber.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;
        card.style.transition = '';
        card.style.transform = '';
        if (dy > 110) closePromo();
      });
    }

    var seen = false;
    if (cfg.once) {
      try { seen = sessionStorage.getItem('state-promo-seen') === '1'; } catch (e) {}
    }
    var inEditor = window.Shopify && window.Shopify.designMode;
    if (promo.dataset.enabled === 'true' && !seen && !inEditor) {
      setTimeout(openPromo, cfg.delay);
    }
  }

  /* =========================
     Page entrance + init
     ========================= */
  function initAll(root) {
    initMarquees(root);
    initReveal(root);
    initConfigurator(root);
    initFlavorExplorer(root);
    initRitual(root);
    initVersus(root);
    initFaq(root);
    initNewsletter(root);
    initPromo(root);
    onScroll();
  }

  requestAnimationFrame(function () { document.body.classList.add('loaded'); });
  initAll(document);

  // Re-init when sections are (re)loaded in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
